// Konstruksjon av Intl.DateTimeFormat er den dyre delen — lag formatterne én
// gang på modulnivå i stedet for per plan (#14578).
const nbLong = new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

const nbShort = new Intl.DateTimeFormat('nb-NO', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

export function formatDateNb(date: Date | undefined): string | undefined {
    if (!date) return undefined;
    try {
        return nbLong.format(date);
    } catch {
        return undefined;
    }
}

export function formatDateShortNb(date: Date | undefined): string | undefined {
    if (!date) return undefined;
    try {
        return nbShort.format(date);
    } catch {
        return undefined;
    }
}
